import { CardTypes, IPaymentMethod } from 'features/payment/types';

import { CurrentSelectedMethodType } from 'components/payment-method/types';

export const isCreditCardPaymentMethod = (method: IPaymentMethod) =>
  method.credit &&
  method.credit?.cardType !== CardTypes.APPLE_PAY &&
  method.credit?.cardType !== CardTypes.GOOGLE_PAY;

/**
 *  We verify that the payment methods are 'credit' and exclude the case where it is
 * a temporary payment method.
 * */
export const isCreditCardAndGoogleApplePaymentMethod = (method: IPaymentMethod) =>
  method.credit && method.accountIdentifier !== CurrentSelectedMethodType.ADD_NEW_CARD;

export const getSortedMethods = (methods: IPaymentMethod[]) => {
  return methods.sort((a: IPaymentMethod, b: IPaymentMethod) => {
    const aIsCreditCard = isCreditCardPaymentMethod(a);
    const bIsCreditCard = isCreditCardPaymentMethod(b);

    if (aIsCreditCard && !bIsCreditCard) {
      return 1;
    } else if (!aIsCreditCard && bIsCreditCard) {
      return -1;
    }
    return 0;
  });
};
